<template>
  <div class="page">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      class="nav-bar"
      :title="$t('auth.register')"
      left-arrow
      @click-left="back()"
    >
      <template #right>
        <div class="to-login" @click="toLogin()">
          {{ $t("auth.login") }}
        </div>
      </template>
    </van-nav-bar>

    <!-- 主要内容区 -->
    <div class="content">
      <!-- Logo -->
      <div class="logo-wrapper">
        <img src="/img/logo.png" class="logo" alt="logo" style="width: 55px;height: 55px;;" />
        <div class="app-name">汽水音乐</div>
      </div>

      <!-- 注册表单 -->
      <div class="loginForm">
        <!-- 账号输入 -->
        <van-field
          v-model="username"
          clearable
          class="input"
          :placeholder="$t('auth.username_place')"
        >
          <template #left-icon>
            <van-icon name="user-o" color="#999" size="22PX" />
          </template>
        </van-field>

        <!-- 密码输入 -->
        <van-field
          v-model="password"
          :type="passwordType"
          class="input"
          :placeholder="$t('auth.pwd_place')"
        >
          <template #left-icon>
            <van-icon name="lock" color="#999" size="22PX" />
          </template>
          <template #right-icon>
            <van-icon
              :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
              color="#999"
              size="22PX"
              @click="switchPasswordType"
            />
          </template>
        </van-field>

        <!-- 邀请码输入 -->
        <van-field
          v-model="code"
          clearable
          class="input"
          :placeholder="$t('auth.invite_code_place')"
        >
          <template #left-icon>
            <van-icon name="coupon-o" color="#999" size="22PX" />
          </template>
        </van-field>

        <!-- 用户协议 -->

        <!-- 注册按钮 -->
        <van-button
          class="register-btn"
          block
          color="#7C4DFF"
          @click="doRegister()"
        >
          {{$t("auth.register")}}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checked: true,
      username: '',
      code: this.$route.query.code,
      lang: 'en_us',
      password: this.inputValue,
      passwordType: 'password',
    };
  },
  mounted(){
    this.lang = localStorage.getItem("lang") || "ja";
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back(){
      return window.history.back();
    },
    toLogin() {
      this.$router.push("Login");
    },
    doRegister() {
      if(this.username === "" || this.username === null || this.username === undefined){
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if(this.password === "" || this.password === null || this.password === undefined){
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }
      if(this.code === "" || this.code === null || this.code === undefined){
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }
      if(!this.checked){
        this.$toast.fail(this.$t("auth.agreement"));
        return false;
      }
      this.$http({
        method: 'post',
        data:{
          username:this.username,
          password:this.password,
          code:this.code,
          lang: this.lang
        },
        url: 'member_register'
      }).then(res=>{
          if(res.code === 200){
            this.$toast.success(res.msg);
            localStorage.setItem('token',res.data)
            this.$router.push("Mine")
          }else {
            this.$toast.fail(res.msg);
          }
      })
    },
  },
  created() {
    if(localStorage.getItem('token')){
      this.$router.replace("/Mine");
      return;
    }
  }
};
</script>

<style lang="less" scoped>
.page {
  min-height: 100VH;
  background: #fff;
}

/* 顶部导航栏 - 蓝色背景 */
.nav-bar {
  background: #8600ff;
  :deep(.van-nav-bar__title) {
    color: #fff;
    font-size: 18PX;
    font-weight: 500;
  }
  :deep(.van-icon) {
    color: #fff ;
  }
}
 :deep .van-nav-bar .van-icon {
    color: #fff;
}

/* 右上角登录入口 */
.to-login {
  font-size: 15PX;
  color: #fff;
  cursor: pointer;
}

.content {
  padding: 40PX 24PX;
}

.logo-wrapper {
  text-align: center;
  margin-bottom: 30PX;
  .logo {
    width: 65PX;
    height: 65PX;
    object-fit: contain;
    display: block;
    margin: 0 auto;
  }
  .app-name {
    margin-top: 10PX;
    font-size: 20PX;
    font-weight: bold;
    color: #333;
  }
}


.loginForm {
  .input {
    margin-bottom: 18PX;
    border: 1PX solid #ddd;
    border-radius: 8PX;
    background: #fff;
    padding: 15PX 12PX;
    :deep(.van-field__control) {
      font-size: 16PX;line-height: 32PX;
      color: #333;
    }
  }

  /* 用户协议 */
  .agreement {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24PX;
    :deep(.van-checkbox__label) {
      color: #666;
      font-size: 14PX;
    }
    .agreement-text {
      font-size: 14PX;
      color: #666;
      margin-left: 4PX;
    }
  }

  /* 注册按钮 - 紫色与登录页一致 */
  .register-btn {
    height: 50PX;
    border-radius: 8PX;
    font-size: 17PX;
    font-weight: bold;
    background: #7C4DFF !important;
    border: none !important;
  }
  ::v-deep .van-field__control {
    font-size: 14PX;
    color: #333;
  }
  
  /* 修改 placeholder 字体大小 */
  ::v-deep  .van-field__control::placeholder {
    font-size: 14PX;
    color: #999;
  }
}
</style>